import { render } from "./Introductie.vue?vue&type=template&id=cc901520"
import script from "./Introductie.vue?vue&type=script&lang=js"
export * from "./Introductie.vue?vue&type=script&lang=js"

import "./Introductie.vue?vue&type=style&index=0&id=cc901520&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__